import { render, staticRenderFns } from "./project-settings.vue?vue&type=template&id=be72a922&"
import script from "./project-settings.vue?vue&type=script&lang=js&"
export * from "./project-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports